import queryString from 'query-string';
import windowLocation from './windowLocation';

function generateUrlFromPathWithParams(pathname, params) {
  const origin = windowLocation.getOrigin();
  const url = origin + pathname;
  const searchParams = queryString.stringify(params);
  return `${url}?${searchParams}`;
}

export {
  generateUrlFromPathWithParams
};
